<script>
import CallbackButton from "@js/components/Buttons/CallbackButton.vue";
import TextAccordion from "@js/components/Sections/TextBlocks/TextAccordion.vue";
import CatalogButton from "@js/components/Buttons/CatalogButton.vue";

export default {
    name: "WorkingSince",
    components: {CatalogButton, TextAccordion, CallbackButton},
}
</script>

<template>
    <div class="pt-20 hidden md:block">
        <div class="container">
            <div class="grid grid-cols-2 gap-5">
                <div class="">
                    <h2 class="text-3xl font-semibold mb-10">
                        О компании ООО «Дорожные Плиты»
                    </h2>
                    <TextAccordion :minHeight="210">
                        <p class="mb-5">
                            ООО «Дорожные Плиты» – это надежный поставщик железобетонных изделий. Компания
                            специализируется на производстве и продаже дорожных плит, используемых в строительстве
                            дорог, промышленных объектов, подъездных путей и временных площадок.
                        </p>
                        <p class="mb-5">
                            Мы предлагаем широкий ассортимент бетонных плит различных типоразмеров, соответствующих
                            ГОСТ, что гарантирует их долговечность и устойчивость к нагрузкам. Благодаря собственному
                            производству и налаженной логистике, мы обеспечиваем своевременные поставки по Москве и
                            Московской области.
                        </p>
                        <p class="mb-5">
                            ООО «Дорожные Плиты» сотрудничает с строительными компаниями, промышленными предприятиями и
                            частными заказчиками, предоставляя качественные ЖБИ для различных строительных нужд. Мы
                            работаем с любыми объемами заказов, гарантируя надежность продукции и профессиональный
                            подход к каждому клиенту.
                        </p>
                    </TextAccordion>
                    <div class="block md:inline-flex items-center gap-5 mt-8">
                        <CallbackButton class="w-full md:w-auto "/>
                        <CatalogButton class="w-full md:w-auto" :isBlurry="true" :dark="true"/>
                    </div>
                </div>
                <div class="flex items-start justify-center">
                    <img class="h-full object-cover max-w-full rounded-bl-full rounded-tl-full max-h-[400px]"
                         src="@img/about_company/about.webp"
                         alt="Заказать звонок" title="Заказать звонок">
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
